module.exports = "/assets/0f56aa43e36a72932225c5e1b6d6444d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/AC.png
// module id = 1190
// module chunks = 0